import { Injectable } from '@angular/core'
import { Chart } from 'chart.js'
import 'chartjs-plugin-labels'

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  renderChart(ctx: CanvasRenderingContext2D, data: any, options: any) {
    if (!data || !data.gross_sales) {
      // If the data is not available, render a grey chart
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['No data available'],
          datasets: [
            {
              data: [100],
              backgroundColor: ['rgba(229, 231, 235, 1)'],
              borderWidth: 0
            },
            {
              data: [0],
              backgroundColor: ['rgba(255, 255, 255, 1)'],
              borderWidth: 0
            }
          ]
        },
        options: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          cutoutPercentage: 40,
          legend: {
            display: false
          },
          plugins: {
            labels: false
          },
          tooltips: {
            enabled: false
          }
        }
      })
      return
    }
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: options.labels,
        datasets: options.datasets
      },
      options: options.chartOptions
    })
  }
}
